import React from 'react';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';
import { CtaPage } from '../atoms/cta';
import NewsPreview from '../molecules/newsPreview';
import { media } from '../../utils/media-queries';

const InterviewSection = ({ interviews }) => {

  return (
    <>
      <StyledNews>
        {interviews.slice(0, 7).map((article, i) => (

          <NewsPreview
            key={i}
            slug={article.slug}
            type="interview"
            description={article.headline}
            date={article.date}
            time={article.time}
            logo={article.logo}
            src={article.mainImage?.asset.gatsbyImageData}
            alt={article.alt}
            className={i === 3 ? 'landscape' : ''}
          />

        ))}
      </StyledNews>
      {interviews.length > 3 &&
        <div className="btn-wrapper">
          <CtaPage title="See more interview" to="news" light />
        </div>
      }
    </>
  );
};

const StyledNews = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top:1.6rem;
  margin-left: calc(var(--sp-1-8) * -1);
  margin-right: calc(var(--sp-1-8) * -1);
  
  @media ${media.M} {
    grid-column: 2 / 12;
    margin-left:0;
    margin-right:0;
  }
`;

export default InterviewSection;
